import type { GridColumnMenuItemProps, GridPinnedColumnFields } from '@mui/x-data-grid-pro';
import { GridColumnMenuPinningItem } from '@mui/x-data-grid-pro';
import type { TableColumnDTO } from '@tempo-io/roadmap-dto';
import type { OnMoveColumn } from './ColumnMenuMoveItem';
import { ColumnMenuMoveItem } from './ColumnMenuMoveItem';

export type ColumnMenuPositionItemProps = GridColumnMenuItemProps & {
  layoutColumns: TableColumnDTO[];
  pinnedColumns: GridPinnedColumnFields;
  onMoveColumn: OnMoveColumn | undefined;
};

export const ColumnMenuPositionItem = (props: ColumnMenuPositionItemProps) => (
  <>
    <ColumnMenuMoveItem {...props} />
    <GridColumnMenuPinningItem colDef={props.colDef} onClick={props.onClick} />
  </>
);
